export const API_BASE_URL = "https://saree-backend-ec6j.onrender.com";

// export const API_BASE_URL = "https://ecom-api-quindl.onrender.com";

// export const API_BASE_URL = "http://localhost:5000";
